(function () {
    'use strict';

    angular
        .module('app')
        .controller('PrototypeCreateController', PrototypeCreateController);


    function PrototypeCreateController($scope, $rootScope, $filter, $state, $stateParams,
        PrototypeService, SeasonService, UserService, PatternService, WorkflowService, ImageNotAvailableName, toaster, cfpLoadingBar, SharedData) {
        var model = this;

        model.isDisabled = true;
        model.parentPrototypeSeasonalId = 0;
        model.patternId = 0;
        model.patternsCount = -1;
        model.sapBrandId = "";
        model.newPrototypeSeason = {};
        model.ProtoCreate = "";
        model.pageNumber = 1;
        model.pageSize = 50;

        $scope.parentPrototypeSeasonalId = $stateParams.parentPrototypeSeasonalId || 0;
        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] === 5) {
                if (userPermissionRow[1] === 3) {
                    model.ProtoCreate = true;
                }
                if (userPermissionRow[1] === 2) {
                    model.ProtoEdit = true;
                }
            }
        });

        if (!model.ProtoCreate) {
            $state.go('permissionDenied');
        }

        if ($stateParams.parentPrototypeSeasonalId) {
            model.parentPrototypeSeasonalId = $stateParams.parentPrototypeSeasonalId; // Copy Proto
        }

        function getBrands() {
            SharedData.getUserDefaults().then(function (response) {
                if (response) {
                    model.brands = response.brands;
                    model.seasons = response.seasons;
                    model.newPrototypeSeason.selectedBrand = response.brandId;
                    model.newPrototypeSeason.selectedSeason = response.seasonId;
                    model.newPrototypeSeason.DivisionKey = response.divisionKey;
                    if (response.brandId) {
                        model.selectBrand(response.brandId);
                    }

                    if (response.seasonId) {
                        model.loadPatterns(true);
                    }
                }
                cfpLoadingBar.complete();
            });
        }

        function getSeasonsByBrand(brandId, defaultVal) {
            SeasonService.getSeasonsByBrand(brandId).then(function (data) {
                model.seasons = data;
                if (typeof defaultVal !== "undefined") {
                    angular.forEach(model.seasons, function (seasonRow) {
                        if (seasonRow.SeasonId === defaultVal) {
                            model.newPrototypeSeason.selectedSeason = seasonRow;
                        }
                    });
                }
            });
        }

        function getUsersByBrand(brandId) {
            UserService.getUsersByBrand(brandId).then(function (data) {
                model.users = data;
            });
        }

        function getWFGroups(brandId, defaultVal) {
            WorkflowService.getWFGroups(brandId, 4).then(function (data) {
                model.groups = data;
                if (typeof defaultVal !== "undefined") {
                    angular.forEach(model.groups, function (groupRow) {
                        if (groupRow.WFGroupId === defaultVal) {
                            model.newPrototypeSeason.selectedGroup = groupRow;
                        }
                    });
                }
            });
        }

        model.checkPrototypeName = function () {
                    var brandId, seasonId;

                    if (typeof model.newPrototypeSeason.selectedSeason !== 'undefined') {
                        brandId = model.newPrototypeSeason.selectedBrand;
                        seasonId = model.newPrototypeSeason.selectedSeason;
                    }

                    var prototypeName = model.newPrototypeSeason.prototypeName;
                    toaster.clear();
                    PrototypeService.isPrototypeNameExists(0, prototypeName, brandId, seasonId)
                        .then(function (response) {
                            if (response === true) {
                                toaster.pop({ type: 'note', title: 'Name duplication', body: 'You may continue, but please note this name already exists.', timeout: 5000 });
                            }
                        });
                };

            model.selectBrand = function (brandId) {
                model.newPrototypeSeason.Responsible = '';

                model.isDisabled = !brandId;
                getSeasonsByBrand(brandId);
                getUsersByBrand(brandId);
                getWFGroups(brandId);
                model.loadPatterns(true);
                var found = $filter("filter")(model.brands, { BrandId: brandId }, true);

                if (found.length) {
                    model.sapBrandId = found[0].SAPBrandId;
                }
            };

            model.resetFilter = function (removeFilterText) {
                model.patternId = 0;
                if (!removeFilterText)
                    return;
                $scope.filterText = "";
            };

            model.loadPatterns = function (resetFilter) {
                if (resetFilter)
                    model.resetFilter(true);
                var brandId = 0;
                var seasonId = 0;

                if (model.parentPrototypeSeasonalId === 0) {
                    brandId = model.newPrototypeSeason.selectedBrand;
                    seasonId = model.newPrototypeSeason.selectedSeason;
                } else if (model.parentPrototypeSeasonalId > 0) {
                    brandId = model.prototypeDetails.BrandId;
                    seasonId = model.newPrototypeSeason.selectedSeason ? model.newPrototypeSeason.selectedSeason : "";
                }

                if (seasonId > 0) {
                    model.getPatternsByBrandSeason(brandId, seasonId, 0);
                }
            };

            model.setPattern = function (item, prototypeCreateForm) {
                if (item.StatusId === 2 || item.StatusId === 3) {
                    if (prototypeCreateForm) {
                        prototypeCreateForm.productTypeId.$touched = false;
                    }

                    model.patternId = item.PatternId;
                    model.selectedItem = item;

                    PrototypeService.getProductTypeList(item.DevelopmentTypeId).then(function (data) {
                        model.productTypeList = data;

                        if (data.length === 1) {
                            model.newPrototypeSeason.ProductTypeId = data[0].ProductTypeId;
                        }
                    });

                } else {
                    model.patternId = "";
                }
            };

            model.loadPatternPage = function (pageNumber, pageSize) {
                model.pageNumber = pageNumber;
                model.pageSize = pageSize;
                model.loadPatterns(false);
            };

            model.setWindowGridHeight = function () {
                if (window.innerHeight >= 768) {
                    $scope.windowGridHeight = window.innerHeight - 581;
                } else if ($scope.pagerData) {
                    var size = $scope.pagerData.TotalRecords < $scope.pagerData.PageSize ? $scope.pagerData.TotalRecords : $scope.pagerData.PageSize;
                    $scope.windowGridHeight = (size * model.gridOptions.rowHeight) + 46;
                }
            };

            model.getPatternsByBrandSeason = function (brandId, seasonId, patternId, autoSelect) {
                $scope.gridLoading = true;
                if (!model.pageNumber) model.pageNumber = 1;

                var searchObject = {
                    BrandId: brandId,
                    SeasonId: seasonId,
                    PatternId: patternId === 0 ? null : patternId,
                    StatusId: 2,
                    StatusIdSecondary: 3,
                    PatternSeasonalName: !$scope.filterText ? "" : $scope.filterText + "!protoCreate!"
                };

                model.autoSelect = autoSelect;
                model.productTypeList = [];
                model.patternId = null;

                PatternService.searchPatterns(searchObject, model.pageNumber, model.pageSize).then(function (response) {
                    $scope.gridLoading = false;
                    if (response.results) {
                        model.patterns = response;

                        $scope.pagerData = {
                            CurrentPageNumber: model.patterns.currentPage,
                            PageSize: model.patterns.pageSize,
                            TotalPageCount: model.patterns.totalPages,
                            TotalRecords: model.patterns.totalRecords,
                            firstRecord: model.patterns.firstRecord,
                            lastRecord: model.patterns.lastRecord
                        };

                        if (response.results.length === 1 && !model.autoSelect) {
                            if (response.results[0].StatusId === 2) {
                                model.setPattern(response.results[0]);
                            }
                        }
                        model.setWindowGridHeight();
                    } else {
                        model.patterns = "";
                    }
                });
            };

            $scope.validateAccountable = function (obj, prop) {
                if (!obj) return;

                prop = prop || "Responsible";

                //If its not an object or doesn't have the correct property theres nothing we can do.
                if (typeof obj !== "object" || !obj.hasOwnProperty(prop)) {
                    return;
                }

                //If it doesn't look like a user (has an Id property with a value > 0) we will set the prop to null;
                //Otherwise it will pass.
                if (!obj[prop].hasOwnProperty("Id") || obj[prop].Id <= 0) {
                    obj[prop] = null;
                }
            };

            if (model.parentPrototypeSeasonalId === 0) {
                //getBrands();
            }

            if (model.parentPrototypeSeasonalId > 0) {

                PrototypeService.getPrototypeSeasonalDetails(model.parentPrototypeSeasonalId).then(function (prototypeSeasonalDetails) {
                    if (prototypeSeasonalDetails === null) {
                        $state.go('permissionDenied');
                        return;
                    }
                    model.prototypeSeasonalDetails = prototypeSeasonalDetails;
                    model.parentPrototypeId = model.prototypeSeasonalDetails.PrototypeId;

                    PrototypeService.getPrototypeDetails(model.parentPrototypeId).then(function (prototypeDetails) {
                        model.prototypeDetails = prototypeDetails;
                        model.newPrototypeSeason.selectedBrand = model.prototypeDetails.BrandId;
                        model.newPrototypeSeason.DivisionKey = model.prototypeDetails.DivisionKey;
                        model.isDisabled = false;
                        model.sapBrandId = model.prototypeDetails.SAPBrandId;
                        getUsersByBrand(model.prototypeDetails.BrandId);
                        getWFGroups(model.prototypeDetails.BrandId, prototypeSeasonalDetails.WFGroupId);
                        getSeasonsByBrand(model.prototypeDetails.BrandId, prototypeSeasonalDetails.SeasonId);
                        cfpLoadingBar.complete();
                    });
                });
            }

            model.createPrototypeSeason = function (isFormInvalid) {
                if (!isFormInvalid && model.patternId) {
                    $scope.prototypeCreateForm.$setPristine();
                    var getBrandId = "";
                    var getSeasonId = "";
                    if (model.parentPrototypeSeasonalId === 0) {
                        getBrandId = model.newPrototypeSeason.selectedBrand;
                        getSeasonId = model.newPrototypeSeason.selectedSeason;
                    }

                    if (model.parentPrototypeSeasonalId > 0) {
                        getBrandId = model.prototypeDetails.BrandId;
                        getSeasonId = model.newPrototypeSeason.selectedSeason;
                    }

                    model.prototypeData = {
                        PatternId: model.patternId,
                        prototypeName: model.newPrototypeSeason.prototypeName,
                        BrandId: getBrandId,
                        ImageName: ImageNotAvailableName,
                        Division: model.newPrototypeSeason.Division,
                        DivisionKey: model.newPrototypeSeason.DivisionKey

                    };

                    model.prototypeSeasonalData = {
                        CopySeasonalId: model.parentPrototypeSeasonalId,
                        SeasonId: getSeasonId,
                        StatusId: 1,
                        ResponsibleId: model.newPrototypeSeason.Responsible.Id,
                        ProductTypeId: model.newPrototypeSeason.ProductTypeId,
                        WFGroupId: model.newPrototypeSeason.selectedGroup.WFGroupId
                    };

                    PrototypeService.createPrototypeSeasonal(model.prototypeData, model.prototypeSeasonalData, model.patternId)
                        .then(function (response) {
                            if (response.IsSuccessful) {
                                if (model.ProtoEdit) {
                                    $state.go("colorway", { prototypeSeasonalId: response.Data.PrototypeSeasonalId });
                                }
                                toaster.pop({ type: 'success', title: 'Success!', body: 'Colorway created or copied successfully.', timeout: 5000 });
                            }
                            else {
                                toaster.pop({ type: 'error', title: 'Error!', body: response.Message, timeout: 5000 });
                                $scope.prototypeCreateForm.$setPristine();
                                $scope.prototypeCreateForm.$setUntouched();
                            }
                        }, function () {
                            toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error while saving the record. Please contact system administrator.', timeout: 5000 });
                            $scope.prototypeCreateForm.$setPristine();
                            $scope.prototypeCreateForm.$setUntouched();
                        });
                }
                else {
                    $scope.prototypeCreateForm.$setPristine();
                    var validation1 = isFormInvalid ? "Please review all fields indicated in red." : "";
                    var validation2 = !model.patternId ? (validation1 !== "" ? " And " : "") + "Select a Pattern that is in Released Status." : "";

                    toaster.pop({ type: 'error', title: 'Error!', body: validation1 + validation2, timeout: 4000 });
                }
            };
        }
    }) ();
